import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { TutorPage } from "@/components/tutor/tutor-page";
import { requireRole } from "@/lib/session";

export const Route = createFileRoute("/teacher/tutor")({
  ssr: false,
  beforeLoad: () => requireRole("teacher"),
  head: () => ({ meta: [{ title: "MAKAI Tutor · MAKAI Teachers" }] }),
  component: Page,
});

function Page() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const isThreadRoute = pathname.startsWith("/teacher/tutor/");

  if (isThreadRoute) return <Outlet />;

  return (
    <AppShell role="teacher" title="MAKAI Tutor" subtitle="Lesson plans, quizzes & class insights">
      <TutorPage role="teacher" />
    </AppShell>
  );
}
